import { useState } from "react";
import { Box, Button, Dialog, DialogContent, DialogActions } from "@mui/material";
import { SketchPicker, ColorResult } from "react-color";

interface ColorPickerProps {
    color: string;
    onChange: (color: string) => void;
    label?: string;
}

const ColorPicker = ({ color, onChange, label = "Seleccionar color" }: ColorPickerProps) => {
    const [showDialog, setShowDialog] = useState(false);
    const [tempColor, setTempColor] = useState(color);

    const handleColorChange = (color: ColorResult) => setTempColor(color.hex);

    const handleConfirm = () => {
        onChange(tempColor);
        setShowDialog(false);
    };

    const handleCancel = () => {
        setTempColor(color);
        setShowDialog(false);
    };

    return (
        <Box>
            <Box
                sx={{
                    mt: '9px',
                    p: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    cursor: 'pointer',
                    width: 50,
                    height: 50
                }}
                onClick={() => setShowDialog(true)}
            >
                <Box sx={{ width: '100%', height: '100%', borderRadius: '50%', background: color }} />
            </Box>

            <Dialog open={showDialog} onClose={handleCancel}>
                <DialogContent>
                    <SketchPicker color={tempColor} onChange={handleColorChange} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel}>Cancelar</Button>
                    <Button variant="contained" onClick={handleConfirm}>Aceptar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ColorPicker;
